import * as actionType from "../actionType";
import Urls, { postRequest } from "../../common/urls";

/** Max customer keys kept per map to avoid unbounded Redux state (P1 #3). */
const MAX_CUSTOMER_KEYS = 10;

/** Keep at most maxKeys entries: currentKey plus (maxKeys-1) others by insertion order. */
function pruneByCustomerKey(obj, currentKey, maxKeys) {
  const keys = Object.keys(obj);
  if (keys.length <= maxKeys) return obj;
  const kept = [currentKey];
  for (const k of keys) {
    if (k !== currentKey && kept.length < maxKeys) kept.push(k);
  }
  const next = {};
  kept.forEach((k) => (next[k] = obj[k]));
  return next;
}

const initialState = {
  hennigList: {},
  hennigInfo: {},
};

const reducer = (state = initialState, action) => {
  let _hennigList;
  let _customerHennigList;
  switch (action.type) {
    case actionType.hennigUpdateHennigList:
      _hennigList = state.hennigList;
      _hennigList[action.data.customerId] = action.data.hennigData;
      _hennigList = pruneByCustomerKey(_hennigList, action.data.customerId, MAX_CUSTOMER_KEYS);
      return {
        ...state,
        hennigList: {
          ..._hennigList,
        },
      };
    case actionType.hennigUpdateHennigInfo:
      let _hennigInfo = state.hennigInfo;
      _hennigInfo[action.data.customerId] = { ...action.data.hennigInfo };
      _hennigInfo = pruneByCustomerKey(_hennigInfo, action.data.customerId, MAX_CUSTOMER_KEYS);
      return {
        ...state,
        hennigInfo: {
          ..._hennigInfo,
        },
      };
    case actionType.hennigAddNewHennig:
      _hennigList = state.hennigList;
      _hennigList[action.data.customerId] = [
        ..._hennigList[action.data.customerId],
        action.data.hennigInfo,
      ];
      _hennigList = pruneByCustomerKey(_hennigList, action.data.customerId, MAX_CUSTOMER_KEYS);
      return {
        ...state,
        hennigList: {
          ..._hennigList,
        },
      };
    case actionType.hennigUpdateHennig:
      _hennigList = state.hennigList;

      _customerHennigList = _hennigList[action.data.customerId];
      try {
        let _selectedHennig = _customerHennigList.filter(
          (x) => x.sensor_id === action.data.hennigInfo.sensor_id
        )[0];
        _selectedHennig = { ...action.data.hennigInfo };

        _customerHennigList = [
          ..._customerHennigList.filter(
            (x) => x.sensor_id !== action.data.hennigInfo.sensor_id
          ),
          { ..._selectedHennig },
        ];

        _hennigList[action.data.customerId] = [..._customerHennigList];
        _hennigList = pruneByCustomerKey(_hennigList, action.data.customerId, MAX_CUSTOMER_KEYS);

        return {
          ...state,
          hennigList: {
            ..._hennigList,
          },
        };
      } catch (err) {}
      break;
    case actionType.hennigDeleteHennig:
      _hennigList = state.hennigList;
      _customerHennigList = _hennigList[action.data.customerId];
      try {
        _customerHennigList = [
          ..._customerHennigList.filter(
            (x) => x.sensor_id !== action.data.sensorId
          ),
        ];

        _hennigList[action.data.customerId] = [..._customerHennigList];
        _hennigList = pruneByCustomerKey(_hennigList, action.data.customerId, MAX_CUSTOMER_KEYS);

        return {
          ...state,
          hennigList: {
            ..._hennigList,
          },
        };
      } catch (err) {}
      break;
    default:
      return state;
  }
};
export default reducer;